"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-462619fe"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "role-section-contents" };
const _hoisted_2 = { class: "oplus-table-wrapper" };
const _hoisted_3 = { class: "oplus-table oplus-table-hover" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("thead", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("tr", null, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
            class: "role-section-name-cell",
            rowspan: "2"
        }, "業務名"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "休憩"),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "シフト表に表示")
    ])
], -1 /* HOISTED */));
const _hoisted_5 = { class: "roles-name-cell d-flex" };
const _hoisted_6 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_7 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_8 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_9 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_10 = ["open"];
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "詳細")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_12 = { class: "accordion-body" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_14 = {
    key: 0,
    class: "accordion role-details"
};
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "配置スタッフ")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_16 = { class: "accordion-body" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_18 = {
    key: 1,
    class: "accordion role-details"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "タイムプラン")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_20 = { class: "accordion-body" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_22 = { class: "role-accordion-content relative" };
const _hoisted_23 = { class: "flex-end flex-gap flex-wrap mb-2" };
const _hoisted_24 = {
    key: 0,
    class: "loading loading-lg"
};
const _hoisted_25 = { key: 1 };
const _hoisted_26 = {
    key: 2,
    class: "accordion role-details"
};
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "カレンダー")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_28 = { class: "accordion-body" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_30 = { class: "role-accordion-content" };
const SectionRequiredCalendar_vue_1 = __importDefault(require("./SectionRequiredCalendar.vue"));
const SectionTemplateTable_vue_1 = __importDefault(require("./SectionTemplateTable.vue"));
const TemplateSelectorModal_vue_1 = __importDefault(require("./TemplateSelectorModal.vue"));
const SectionTemplateModal_vue_1 = __importDefault(require("./SectionTemplateModal.vue"));
const RoleSectionForm_vue_1 = __importDefault(require("./RoleSectionForm.vue"));
const SectionEmployeeList_vue_1 = __importDefault(require("./SectionEmployeeList.vue"));
const role_requests_1 = require("../../js/role_requests");
const vue_3 = require("vue");
const EmptyContent_vue_1 = __importDefault(require("../../vue/components/EmptyContent.vue"));
const RoleCreateButton_vue_1 = __importDefault(require("../../vue/components/RoleCreateButton.vue"));
const ImportButton_vue_1 = __importDefault(require("../../vue/components/ImportButton.vue"));
const ImportModal_vue_1 = __importDefault(require("../../vue/ImportModal.vue"));
const common_1 = require("../../js/common");
const roleSectionTemplateRequest_1 = require("../../requests/roleSectionTemplateRequest");
const roleSectionTemplateStore_1 = require("../../store/v1/roleSectionTemplateStore");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roles_1 = require("../../js/roles");
const errors_1 = __importDefault(require("../../js/errors"));
const provider_1 = require("../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionSubContent',
    emits: ["updated-selected-role"],
    setup(__props, { emit: __emit }) {
        const { addRoleSection } = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewInjectionKey, { addRoleSection: () => { }, deleteRoleSection: () => { } });
        const { setNewGroupRoleBranch } = (0, vue_3.inject)(roleSectionInjectionKeys_1.GroupRoleSectionViewInjectionKey, { openGroupRoleBranchModal: () => { }, setNewGroupRoleBranch: () => { } });
        const groupRoleBranchPresenter = (0, vue_3.inject)(provider_1.groupRoleBranchInjectKey, undefined)?.presenter;
        const selectedRole = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewSelectedRole, undefined);
        const meStore = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleViewMeStore, undefined);
        const isGroupSectionPage = (0, vue_3.inject)(roleSectionInjectionKeys_1.GroupRoleSectionInjectionKey, false);
        const sectionTimeplanImportModal = (0, vue_3.ref)(null);
        const templateStore = (0, vue_3.ref)(new roleSectionTemplateStore_1.RoleSectionTemplateStore());
        const data = (0, vue_3.ref)({
            isFormLoading: false,
            isSectionTemplateModalActive: false,
            isTemplateSelectorModalActive: false,
        });
        const emit = __emit;
        const selectedRoleTemplateId = (0, vue_3.ref)(undefined);
        const isTableLoading = (0, vue_3.ref)(false);
        // SectionTemplateModal
        const isOverride = (0, vue_3.ref)(false);
        // Calendar
        const selectedWeekIndex = (0, vue_3.ref)(-1);
        const selectedCalendarDate = (0, vue_3.ref)("");
        const templateIdsInCell = (0, vue_3.ref)([]);
        const isWeeklyCellClicked = (0, vue_3.ref)(false);
        const activeUserId = meStore?.getActiveUserId() || "";
        const roleSectionTemplates = (0, vue_3.computed)(() => {
            return templateStore.value.query();
        });
        const roleColor = (0, vue_3.computed)(() => {
            return {
                'color': selectedRole?.value?.color ? "#fff" : "",
                'background-color': selectedRole?.value?.color ? `#${selectedRole?.value?.color}` : "",
                'border-radius': "3px",
            };
        });
        const computedRoleName = (0, vue_3.computed)(() => {
            return selectedRole?.value?.getName() || '業務名';
        });
        function resetStateData() {
            selectedCalendarDate.value = "";
            selectedWeekIndex.value = -1;
            templateIdsInCell.value = [];
            isWeeklyCellClicked.value = false;
            selectedRoleTemplateId.value = undefined;
            isOverride.value = false;
        }
        function handleRoleSectionSubmit(emittedData) {
            if (selectedRole?.value) {
                updateRoleSection(emittedData);
                return;
            }
            createRoleSection(emittedData);
        }
        // Section Table
        function handleSectionTemplateModal() {
            selectedRoleTemplateId.value = undefined;
            data.value.isSectionTemplateModalActive = true;
        }
        function handleSectionTemplateClose() {
            resetStateData();
            data.value.isSectionTemplateModalActive = false;
        }
        function handleTemplateSelectorModal() {
            data.value.isTemplateSelectorModalActive = true;
        }
        function handleTemplateSelectorClose() {
            resetStateData();
            data.value.isTemplateSelectorModalActive = false;
        }
        function handleTemplateEmitData(templateId) {
            selectedRoleTemplateId.value = templateId;
            data.value.isSectionTemplateModalActive = true;
        }
        function handleTemplateEmitDelete(templateId) {
            deleteRoleSectionTemplate(templateId);
        }
        // Calendar
        function handleSelectedWeekCell(emittedData) {
            data.value.isTemplateSelectorModalActive = true;
            isWeeklyCellClicked.value = true;
            selectedCalendarDate.value = "";
            selectedWeekIndex.value = emittedData.weekIndex;
            templateIdsInCell.value = emittedData.templateIds;
        }
        function handleSelectedCalendarDate(emittedData) {
            data.value.isTemplateSelectorModalActive = true;
            isWeeklyCellClicked.value = false;
            selectedCalendarDate.value = emittedData.dateStr;
            selectedWeekIndex.value = emittedData.weekIndex;
            templateIdsInCell.value = emittedData.templateIds;
        }
        function handleOverrideTemplateSelect(emittedData) {
            data.value.isTemplateSelectorModalActive = false;
            data.value.isSectionTemplateModalActive = true;
            isOverride.value = true;
            if (emittedData.overrideDate) {
                selectedCalendarDate.value = emittedData.overrideDate;
            }
            if (emittedData.templateId) {
                selectedRoleTemplateId.value = emittedData.templateId;
            }
        }
        async function updateRoleSection(emittedData) {
            try {
                data.value.isFormLoading = true;
                const payload = { ...emittedData.formData };
                const response = await (0, role_requests_1.putRoleRequest)(emittedData.roleId, payload);
                addRoleSection(response.role);
                emit("updated-selected-role", response.role.ID);
                (0, roles_1.openSuccessModal)("業務セクションを編集しました。");
            }
            catch (err) {
                (0, roles_1.openAlertModal)(errors_1.default.ROLE.UPDATE);
            }
            finally {
                data.value.isFormLoading = false;
            }
        }
        async function createRoleSection(emittedData) {
            try {
                data.value.isFormLoading = true;
                const payload = { ...emittedData.formData };
                const response = await (0, role_requests_1.createRoleRequest)(payload);
                addRoleSection(response.role);
                emit("updated-selected-role", response.role.ID);
                setNewGroupRoleBranch(response.role.ID);
                groupRoleBranchPresenter?.updateActiveBranchCounts(response.role.ID);
                (0, roles_1.openSuccessModal)("業務セクションを作成しました。");
            }
            catch (err) {
                (0, roles_1.openAlertModal)(errors_1.default.ROLE.CREATE);
            }
            finally {
                data.value.isFormLoading = false;
            }
        }
        async function deleteRoleSectionTemplate(templateId) {
            try {
                const payload = {
                    branchId: meStore?.getActiveBranchId() || "",
                    templateId: parseInt(templateId || "0"),
                    delete: true,
                };
                await (0, roleSectionTemplateRequest_1.patchRoleSectionTemplates)(parseInt(activeUserId), payload);
                templateStore.value.delete(templateId || "0");
            }
            catch (err) {
                (0, roles_1.openAlertModal)(err);
            }
        }
        function handleNewTemplate(newTemplate) {
            if (newTemplate.template) {
                templateStore.value.add(newTemplate.template);
                // Add skip date to the overridden repeat template;
                if (newTemplate.overrideDate && newTemplate.overrideTemplateId) {
                    templateStore.value.byId(newTemplate.overrideTemplateId)?.addSkipDays(new Date(newTemplate.overrideDate));
                }
            }
        }
        function handleRemoveTemplateFromCell(emittedData) {
            handleNewTemplate(emittedData);
            if (emittedData.template?.getId()) {
                const toRemoveIdx = templateIdsInCell.value.indexOf(emittedData.template.getId());
                templateIdsInCell.value.splice(toRemoveIdx, 1);
            }
        }
        function openSectionTimeplanImportModal() {
            sectionTimeplanImportModal.value?.openModal();
        }
        (0, vue_3.onMounted)(async () => {
            if (!selectedRole?.value) {
                return;
            }
            isTableLoading.value = true;
            try {
                const payload = {
                    branchId: meStore?.getActiveBranchId() || "",
                    roleSectionId: parseInt(selectedRole.value.getId()),
                };
                const templates = await (0, roleSectionTemplateRequest_1.getRoleSectionTemplates)(parseInt(activeUserId), payload);
                templates.forEach(t => {
                    templateStore.value.add(t);
                });
            }
            catch (err) {
                console.error(err);
                (0, roles_1.openAlertModal)(err);
            }
            finally {
                isTableLoading.value = false;
            }
        });
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleViewTemplateStore, templateStore);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#app" }, [
                    (data.value.isSectionTemplateModalActive)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SectionTemplateModal_vue_1.default, {
                            key: 0,
                            "role-template-id": selectedRoleTemplateId.value,
                            "is-override": isOverride.value,
                            "selected-date": selectedCalendarDate.value,
                            onEmitCloseModal: handleSectionTemplateClose,
                            onEmitNewTemplate: handleNewTemplate
                        }, null, 8 /* PROPS */, ["role-template-id", "is-override", "selected-date"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (data.value.isTemplateSelectorModalActive)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TemplateSelectorModal_vue_1.default, {
                            key: 1,
                            onEmitCloseModal: handleTemplateSelectorClose,
                            onEmitUpdatedTemplate: handleNewTemplate,
                            onEmitSelectedOverride: handleOverrideTemplateSelect,
                            onEmitRemoveTemplateCell: handleRemoveTemplateFromCell,
                            "selected-week-index": selectedWeekIndex.value,
                            "selected-calendar-date": selectedCalendarDate.value,
                            "templates-in-cell": templateIdsInCell.value,
                            "is-weekly-cell-clicked": isWeeklyCellClicked.value
                        }, null, 8 /* PROPS */, ["selected-week-index", "selected-calendar-date", "templates-in-cell", "is-weekly-cell-clicked"]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createVNode)(ImportModal_vue_1.default, {
                        ref_key: "sectionTimeplanImportModal",
                        ref: sectionTimeplanImportModal,
                        "modal-name": "section-timeplan-import-modal",
                        "import-URL": `/dashboard/${(0, vue_2.unref)(activeUserId)}/role_section_template/bulk_import?c=${(0, vue_2.unref)(meStore)?.getActiveBranchId()}`,
                        "csv-name": "タイムプラン",
                        "content-text": "CSVファイルから業務の登録や必要人数の設定を行うことができます。",
                        "excel-download-link": "https://storage.googleapis.com/opluswork.com/dashboard/%E3%82%BF%E3%82%A4%E3%83%A0%E3%83%95%E3%82%9A%E3%83%A9%E3%83%B3%E3%82%A4%E3%83%B3%E3%83%9B%E3%82%9A%E3%83%BC%E3%83%88.xlsx",
                        "error-message": "",
                        "success-callback": (0, vue_2.unref)(common_1.refreshOnSuccess),
                        "error-callback": (0, vue_2.unref)(roles_1.sectionImportErrorCallback),
                        "section-id": (0, vue_2.unref)(selectedRole)?.getId() || ''
                    }, null, 8 /* PROPS */, ["import-URL", "success-callback", "error-callback", "section-id"])
                ])),
                (0, vue_2.createCommentVNode)(" Contents "),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("table", _hoisted_3, [
                            _hoisted_4,
                            (0, vue_2.createElementVNode)("tbody", null, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                            (0, vue_2.createElementVNode)("span", {
                                                class: "role-name text-popup px-2",
                                                style: (0, vue_2.normalizeStyle)(roleColor.value)
                                            }, (0, vue_2.toDisplayString)(computedRoleName.value), 5 /* TEXT, STYLE */)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        ((0, vue_2.unref)(selectedRole)?.isRestSection)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_6))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_7))
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        ((0, vue_2.unref)(selectedRole)?.showCount || !(0, vue_2.unref)(selectedRole))
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_8))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createCommentVNode)(" Details/Form "),
                    (0, vue_2.createElementVNode)("details", {
                        class: "accordion role-details",
                        open: !(0, vue_2.unref)(selectedRole)
                    }, [
                        _hoisted_11,
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            _hoisted_13,
                            (0, vue_2.createVNode)(RoleSectionForm_vue_1.default, {
                                onRoleSectionOnSubmit: handleRoleSectionSubmit,
                                "is-form-loading": data.value.isFormLoading
                            }, null, 8 /* PROPS */, ["is-form-loading"])
                        ])
                    ], 8 /* PROPS */, _hoisted_10),
                    (0, vue_2.createCommentVNode)(" Employee assign (auto) "),
                    ((0, vue_2.unref)(selectedRole) && !(0, vue_2.unref)(isGroupSectionPage))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", _hoisted_14, [
                            _hoisted_15,
                            (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                _hoisted_17,
                                (0, vue_2.createVNode)(SectionEmployeeList_vue_1.default, {
                                    "user-id": Number((0, vue_2.unref)(activeUserId)),
                                    "branch-id": Number((0, vue_2.unref)(meStore)?.getActiveBranchId() || '')
                                }, null, 8 /* PROPS */, ["user-id", "branch-id"])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" Time plan (templates) "),
                    ((0, vue_2.unref)(selectedRole) && !(0, vue_2.unref)(isGroupSectionPage))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", _hoisted_18, [
                            _hoisted_19,
                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                _hoisted_21,
                                (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                        (0, vue_2.createVNode)(ImportButton_vue_1.default, { onOpenImportModal: openSectionTimeplanImportModal }),
                                        (0, vue_2.createVNode)(RoleCreateButton_vue_1.default, { onOpenCreateModal: handleSectionTemplateModal })
                                    ]),
                                    (isTableLoading.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_24))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                                            (roleSectionTemplates.value.length)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SectionTemplateTable_vue_1.default, {
                                                    key: 0,
                                                    "role-section-templates": roleSectionTemplates.value,
                                                    onEmitTemplateData: handleTemplateEmitData,
                                                    onEmitTemplateDelete: handleTemplateEmitDelete
                                                }, null, 8 /* PROPS */, ["role-section-templates"]))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(EmptyContent_vue_1.default, {
                                                    key: 1,
                                                    title: 'タイムプランがありません。',
                                                    "sub-title": '上の作成ボタンから業務を作成してください。'
                                                }))
                                        ]))
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createCommentVNode)(" Calendar "),
                    ((0, vue_2.unref)(selectedRole) && !(0, vue_2.unref)(isGroupSectionPage))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("details", _hoisted_26, [
                            _hoisted_27,
                            (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                _hoisted_29,
                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                    (0, vue_2.createVNode)(SectionRequiredCalendar_vue_1.default, {
                                        onEmitTemplateSelector: handleTemplateSelectorModal,
                                        onEmitCalendarWeekIndex: handleSelectedWeekCell,
                                        onEmitCalendarCellDate: handleSelectedCalendarDate
                                    })
                                ])
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])
            ]));
        };
    }
});
